import React from 'react';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import GraphLineIcon from '@atlaskit/icon/glyph/graph-line';
import QueuesIcon from '@atlaskit/icon/glyph/queues';
import { IconButton } from '@atlaskit/button/new';
import HipchatLobbyIcon from '@atlaskit/icon/glyph/hipchat/lobby';
import Question from '@atlaskit/icon/glyph/question';
import { analytics } from '../services/analytics';

const supportClick = (supportLocation) => {
    analytics.track({
        userId: window.license,
        event: 'accessed_support',
        timestamp: new Date(),
        properties: {
            addon_key: process.env.REACT_APP_KEY,
            support_location: supportLocation,
        },
    });
};

const HelpMenuTrigger = (params) => {
    const { triggerRef, ...props } = params;
    return <IconButton {...props} icon={Question} label="more" ref={triggerRef} />;
};

const HelpMenu = () => (
    <DropdownMenu trigger={HelpMenuTrigger} position="bottom right">
        <DropdownItemGroup>
            <DropdownItem
                elemBefore={<GraphLineIcon />}
                href="https://apps.appf.re/oc/doc/p2"
                target="_new"
                onClick={() => supportClick('support_menu_intro')}
            >
                Getting started
            </DropdownItem>
            <DropdownItem
                elemBefore={<QueuesIcon />}
                href="https://apps.appf.re/oc/doc"
                target="_new"
                onClick={() => supportClick('support_menu_docs')}
            >
                Documentation
            </DropdownItem>
            <DropdownItem
                elemBefore={<HipchatLobbyIcon />}
                href="https://apps.appf.re/oc/support/p2"
                target="_new"
                onClick={() => supportClick('support_menu_support')}
            >
                Contact support
            </DropdownItem>
        </DropdownItemGroup>
    </DropdownMenu>
);

export default HelpMenu;
